<template>
    <div class="min-w-100">
        {{ date }}
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "date-cell",
    props: {
        cell: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
    },
    computed: {
        date() {
            let date = this.cell.datetime;
            return date ? moment(date).locale("es").format("DD/MM/YYYY") : "-";
        },
    },
};
</script>